const Error = ({ message }) => {
  return (
    <>
      <p className="text-red-600 text-[12px]">{message}</p>
    </>
  );
};

export default Error;
